export const ContractType = {
  PaperContract: "TMVSA",
  HostingContract: "MSSA"
};

export const ContractTypeDescription = {
  PaperContract: "PaperContract",
  HostingContract: "HostingContract"
};
